export function calculateDrivingHours(travel){

    var pTravel = parseFloat(travel);

    if(pTravel <= 1 ) return "0";

    var drivingHours = pTravel >= hoursMap[hoursMap.length -1].lower ? hoursMap[hoursMap.length -1]
    : hoursMap.filter(t => pTravel <= t.upper && pTravel >= t.lower)[0];

    return drivingHours.value;
}

const hoursMap = [
    {lower:1,upper:19, value:"15"},
    {lower:20,upper:38, value:"25"},
    {lower:39,upper:56, value:"35"},
    {lower:57,upper:75, value:"45"},
    {lower:76, value:"100"},
];


// WEBPACK FOOTER //
// ./src/helpers/DrivingHoursConverter.js